import { Button, Grid, Typography } from "@material-ui/core"
import { modalStressTextColor, subContentColor } from "../lib/Color";
import BattleResultLine, { BattleResultLineType } from "./BattleResultLine";
import TeamArea, { BattleResultTeamType } from "./teamArea/TeamArea";
import { Link as Scroll } from 'react-scroll';
import { MemberType, TeamType } from "../Type/TeamType";
import { BattleResultMemberType } from "./teamArea/TeamAreaRow";

type Props = {
    onBackButtonClick: () => void,
    attack: TeamType,
    defence: TeamType,
    battleResultLines: BattleResultLineType[]
    victory: string
}

const BattleResultArea = ({ onBackButtonClick, attack, defence, battleResultLines, victory }: Props) => {
    console.log(battleResultLines)
    const makeBattleResultTeamMemberData = (member: MemberType): BattleResultMemberType => {
        const total = (hero?: number, leftExtension?: number, rightExtension?: number) => {
            let num = 0;
            if (hero) {
                num += Number(hero)
            }
            if (leftExtension) {
                num += Number(leftExtension)
            }
            if (rightExtension) {
                num += Number(rightExtension)
            }
            return num
        }

        return {
            heroId: member.hero?.id,
            leftExtensionId: member.leftExtension?.id,
            rightExtensionId: member.rightExtension?.id,
            hp: total(member.hero?.hp, member.leftExtension?.hp, member.rightExtension?.hp),
            phy: total(member.hero?.phy, member.leftExtension?.phy, member.rightExtension?.phy),
            int: total(member.hero?.int, member.leftExtension?.int, member.rightExtension?.int),
            agi: total(member.hero?.agi, member.leftExtension?.agi, member.rightExtension?.agi),
        }
    }
    const makeBattleResultTeamData = (team: TeamType): BattleResultTeamType => {
        return {
            front: makeBattleResultTeamMemberData(team.front),
            middle: makeBattleResultTeamMemberData(team.middle),
            back: makeBattleResultTeamMemberData(team.back),
        }
    }
    return (
        <Grid spacing={3}>
            <Grid container direction="column" alignItems="center" style={{ backgroundColor: subContentColor, height: '35vh' }}>
                <TeamArea {...makeBattleResultTeamData(attack)} />
            </Grid>
            <Grid container alignItems="center" direction="column">
                <Grid item style={{ margin: "5px" }} >
                    <Typography variant="h4">
                        <span style={{ color: modalStressTextColor }}>VS</span>
                    </Typography>
                </Grid>
            </Grid>
            <Grid container direction="column" alignItems="center" style={{ backgroundColor: subContentColor, height: '35vh' }}>
                <TeamArea {...makeBattleResultTeamData(defence)} />
            </Grid>
            <Grid container alignItems="center" direction="column" style={{ marginTop: "10px" }}>
                <Scroll to="buttle-result" smooth={true}>
                    <Button size={"large"} variant="contained" color="secondary">
                        skip
                    </Button>
                </Scroll>
            </Grid>
            <hr />

            {battleResultLines.length && battleResultLines.map((battleResultLine, key) => <BattleResultLine teamCount={key} selectedAttackTeam={attack} selectedDefenceTeam={defence} {...battleResultLine} />)}
            <hr />
            <Grid container alignItems="center" direction="column" style={{ margin: "10px" }}>
                <Typography variant={"h2"} style={{ color: modalStressTextColor, margin: "10" }}>勝者:  {victory}</Typography>
            </Grid>
            <Grid container alignItems="center" direction="column" style={{ margin: "10px" }}>
                <div id="buttle-result"></div>
                <Button size={"large"} variant="contained" color="secondary" onClick={onBackButtonClick}>
                    戻る
                </Button>
            </Grid>
        </Grid>
    );
}

export default BattleResultArea;